import { useEffect } from 'react';

import { useLogoutMutation } from '@/store';

export function Logout() {
  const [logout] = useLogoutMutation();

  useEffect(() => {
    logout();
  }, [logout]);

  return null;
}
